module.exports = __webpack_public_path__ + "media/entities/5101-6f7bc386.png";